import { HTMLAttributes } from "react"
import { styled, StyleProps, CSSFn, callCSSFn } from "../styles"

export interface ListProps extends HTMLAttributes<HTMLElement> {
  children: React.ReactNode | React.ReactNode[]
  css?: CSSFn
}

export const List = (props: ListProps) => <StyledList role="tablist" {...props} />

List.defaultProps = {
  css: undefined,
}

const StyledList = styled.nav<ListProps>((props: ListProps & StyleProps) => ({
  display: `inline-block`,
  marginRight: `auto`,
  border: `1px solid hsla(0, 0%, 0%, .1)`,
  borderRadius: 3,
  marginBottom: props.theme.spacing(8),
  ...callCSSFn(props),
}))
